import ModalTaxInvoice from 'components/OrderManage/OrderTabsCard/ModalTaxInvoice';
import { useGetTaxInvoiceByOrderId } from 'hooks/useOrders';
import { LoadTaxInvoiceData, LoadTaxInvoiceItems } from 'services/interface';
import { useAppDispatch, useAppSelector } from 'store';
import { formatDate, formatDateWithTime } from 'utils/dateFormat';
import styled from '@emotion/styled';
import { Button, Col, Row, Typography } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import React, { FC, useState } from 'react'
import { FileTextOutlined } from '@ant-design/icons';
import ExportToExcel from '../ExportToExcel';
import { setLoading } from 'store/slices/loadingSlice';
import SearchTaxForm from '../SearchTaxForm';

interface TableInvoiceRequestTableProps {
    data: LoadTaxInvoiceData | undefined;
    searchInput: string;
    setSearchInput: React.Dispatch<React.SetStateAction<string>>;
    dateStartInput: string
    setDateStartInput: React.Dispatch<React.SetStateAction<string>>
    dateEndInput: string
    setDateEndInput: React.Dispatch<React.SetStateAction<string>>
    limit?: number;
    handleSetLimit: (value: number) => void;
    handleSetOffset: (value: number) => void;
}
  
const TableInvoiceRequestTable : FC<TableInvoiceRequestTableProps> = (
    { 
      data,
      searchInput,
      setSearchInput,
      dateStartInput,
      setDateStartInput,
      dateEndInput,
      setDateEndInput,
      limit,
      handleSetLimit,
      handleSetOffset
    }) => {
        const dispatch = useAppDispatch();
        const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);

        const [open, setOpen] = useState<boolean>(false);
        const [taxData, setTaxData] = useState<LoadTaxInvoiceItems>();
      
        const { mutate: getTaxInvoice } = useGetTaxInvoiceByOrderId();
        const columns: ColumnsType<LoadTaxInvoiceItems> = [
          {
            title: "Order No.",
            dataIndex: "order_code",
            key: "order_id",
            render: (_text, record) => {
              return (
                <Typography.Text
                  style={{
                    display: "flex", alignItems: "center", margin: 0, padding: 0,
                  }}
                >
                  {record.order_code}
                </Typography.Text>
              );
            },
          },
          {
            title: "วันที่สั่งซื้อ",
            dataIndex: "order_date",
            render: (_text) => {
              return (
                <Typography>
                  {_text ? formatDateWithTime(_text) : '-'}
                </Typography>
              );
            },
          },
          {
            title: "วันที่ต้องส่งสินค้า",
            dataIndex: "due_date",
            render: (_text) => {
              return (
                <Typography>
                  {_text ? formatDate(_text) : '-'}
                </Typography>
              );
            },
          },
          {
            title: "ชื่อ-สกุล/บริษัท",
            dataIndex: "tax_name",
            render: (_text) => {
              return (
                <Typography>
                  {_text ? _text : '-'}
                </Typography>
              );
            },
          },
          {
            title: "หมายเลขประจำตัวผู้เสียภาษีอากร",
            dataIndex: "tax_no",
            render: (_text) => {
              return (
                <Typography>
                  {_text ? _text : '-'}
                </Typography>
              );
            },
          },
          {
            title: "เบอร์โทรศัพท์",
            dataIndex: "telephone",
            render: (_text) => {
              return (
                <Typography>
                  {_text ? _text : '-'}
                </Typography>
              );
            },
          },
          {
            title: "ใบกำกับภาษี",
            align: "center",
            width: 100,
            fixed: 'right',
            render: (_text, record) => {
              return (
              <>
              <Button
                type="default"
                size="small"
                style={{
                  fontSize:'10px'
                }}
                onClick={()=> {
                  dispatch(setLoading(true));
                  getTaxInvoice({
                    order_id: record.order_id,
                    factory_id: factoryId || '',
                  },
                    {
                      onSuccess: async (res: any) => {
                        res && setTaxData(res.data[0]);
                        await new Promise((resolve) => setTimeout(resolve, 200));
                        dispatch(setLoading(false));
                        setOpen(true);
                      },
                      onError: (error) => {
                        console.log(error);
                        dispatch(setLoading(false));
                      },
                    }
                  );
                }}
              >
                <FileTextOutlined /> 
                {/* ใบกำกับภาษี */}
              </Button>
            </>
              )
            }
          },
           
        ];        
    return (
        <WrapperAll>
        <HeadWrapper>
          <SearchTaxForm 
              searchInput={searchInput} 
              setSearchInput={setSearchInput}
              setDateStartInput={setDateStartInput}
              dateStartInput={dateStartInput}
              dateEndInput={dateEndInput}
              setDateEndInput={setDateEndInput}
          />  
          <ExportToExcel
            searchInput={searchInput}
            dateStartInput={dateStartInput}
            dateEndInput={dateEndInput}
          />
        </HeadWrapper>
  
        <Row
          gutter={[16, 16]}
          style={{ marginTop:"10px",backgroundColor: "#EFEFEF", overflow: "auto" }}
        >
          <Col span={24}>
            <Table 
              rowKey="order_id"
              size="small"
              scroll={{x:true}}
              columns={columns}
              dataSource={data?.data} 
              pagination={{
                pageSize: limit,
                total: parseInt((data?.total_record ?? 0) as string),
                onChange: (page, pageSize) => {
                  handleSetOffset(pageSize! * (page! - 1));
                  handleSetLimit(pageSize!);
                },
              }}
            />
          </Col>
        </Row>
        <ModalTaxInvoice
          open={open}
          setOpen={setOpen}
          item={taxData}
        />
      </WrapperAll>
  )
}

export default TableInvoiceRequestTable

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;